import { fetchCustomer, fetchCustomers, saveCustomer } from '../../../services/CustomerService';

import { DEFAULT_PAGE_SIZE } from '../../../constants';

export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const CUSTOMER_EDITING = 'CUSTOMER_EDITING';

// ACTION GENERATORS

const fetchCustomersAction = (pageNumber = 1, pageSize = DEFAULT_PAGE_SIZE) => ({
    type: FETCH_CUSTOMERS,
    payload: fetchCustomers(pageNumber, pageSize),
});

const fetchCustomerAction = customerId => ({
    type: FETCH_CUSTOMER,
    payload: fetchCustomer(customerId),
});

const newCustomerAction = () => ({
    type: `${FETCH_CUSTOMER}_FULFILLED`,
    payload: null,
});

const saveCustomerAction = customer => ({
    type: FETCH_CUSTOMER,
    payload: saveCustomer(customer),
});

const editModeAction = isEditing => ({
    type: CUSTOMER_EDITING,
    payload: isEditing,
});

// EXPORT ACTIONS

export {
    fetchCustomerAction as fetchCustomer,
    fetchCustomersAction as fetchCustomers,
    newCustomerAction as newCustomer,
    saveCustomerAction as saveCustomer,
    editModeAction as setCustomerEditMode,
};
